import React, { useEffect, useState} from 'react';
import { Modal } from 'antd';
import { Button } from "@vds/buttons";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useDispatch } from 'react-redux';
import { updateUI } from "../../store/actions/deviceProfile";


const ValidateDeviceProfileModal = ({popupName, popupTitle, customClass, open, children, handler}) => {
  const dispatch = useDispatch();
  const showLoading = (e) => {
    if(handler){
      e.preventDefault();
      handler()
    }
  };
  const enhancedChildren = React.cloneElement(children, );

  const handleCancel = () => {
      dispatch(updateUI({
        key: "activeShipmentPopup",
        value: {
          isOpen: false,
          type: "",
        }
      })); 
  };

  return (
    <>
      <Modal
        footer={null}
        open={open}
        onCancel={handleCancel}
        className={customClass}
      >

        <div style={{ marginBottom: "20px" }}>
          <h2 className={"font-face-vzb page-heading-user"}>
              {popupName}
          </h2>
          <h4 className={"font-face-vzb page-sub-heading-user"} style={{fontSize:'32px',lineHeight:'36px',marginTop:'19px'}}>
            {popupTitle}
          </h4>
        </div>
          {enhancedChildren}
      </Modal>
    </>
  );
};

export default ValidateDeviceProfileModal;